var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-5"},[_c('a-button',{class:_vm.customStyle,attrs:{"type":_vm.color,"block":""},on:{"click":_vm.callAction}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }